import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import { Privacy, Terms } from "@/pages/Legal";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Help from "@/pages/Help";
import Careers from "@/pages/Careers";
import Press from "@/pages/Press";
import Blog from "@/pages/Blog";
import Security from "@/pages/Security";
import Pilot from "@/pages/Pilot";
import Feedback from "@/pages/Feedback";
import PostRepayment from "@/pages/PostRepayment";
import Accept from "@/pages/Accept";

function App() {
  // Capture ?ref=CODE once and stash in sessionStorage for the whole session
  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const ref = (params.get("ref") || "").trim().toUpperCase();
      if (ref && /^[A-Z2-9]{6,12}$/.test(ref)) {
        sessionStorage.setItem("gf_ref", ref);
      }
    } catch { /* noop */ }
  }, []);
  return (
    <div className="App bg-[#050505] text-white min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/help" element={<Help />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/press" element={<Press />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/security" element={<Security />} />
          <Route path="/pilot" element={<Pilot />} />
          <Route path="/pilot/feedback/:appId" element={<Feedback />} />
          <Route path="/pilot/repaid/:appId" element={<PostRepayment />} />
          <Route path="/pilot/accept/:appId" element={<Accept />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-center"
        toastOptions={{
          style: {
            background: "#0A0A0A",
            border: "1px solid rgba(0,255,136,0.25)",
            color: "#fff",
          },
        }}
      />
    </div>
  );
}

export default App;
